<xpo-shell [drawerClosedByDefault]="true">
  <xpo-header-app-name>Edge</xpo-header-app-name>
  <xpo-header-sub-app-name>Mobile Weblinks Maintenance </xpo-header-sub-app-name>
  <xpo-header-navigation>
    <button routerLink="/weblinks-add" routerLinkActive="xpo-selected">Add Weblink</button>
    <button routerLink="/weblinks-status" routerLinkActive="xpo-selected">Weblinks Status</button>
  </xpo-header-navigation>
  <xpo-header-actions>
    <xpo-auth-user-profile></xpo-auth-user-profile>
  </xpo-header-actions>
  <div class="root-container">
    <div class="root-container-main">
      <router-outlet></router-outlet>
    </div>
    <xpo-footer xpoFooterSticky [version]="build"></xpo-footer>
  </div>
</xpo-shell>
<xpo-app-notification></xpo-app-notification>